import React from "react";
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import forgetPasswordImg from "../../../../img/verification.svg";
import {
  useAuthState,
  useSendEmailVerification,
} from "react-firebase-hooks/auth";
import { auth } from "../../../../firebase.init";
import { toast } from "react-toastify";
const EmailVerified = () => {
  const [user] = useAuthState(auth);

  //   handle Toast
  const toastId = React.useRef(null);
  const notify = () =>
    (toastId.current = toast("Sending", { autoClose: true }));
  const update = () =>
    toast.update(toastId.current, {
      render: "Successfully Send",
      type: toast.TYPE.SUCCESS,
      autoClose: 1000,
    });

  const [sendEmailVerification, sending, error] =
    useSendEmailVerification(auth);

  const handleSendverified = async () => {
    await sendEmailVerification();
    update();
  };

  if (error) {
    return (
      <div>
        <p>Error: {error.message}</p>
      </div>
    );
  }
  if (sending) {
    notify();
  }

  return (
    <div>
      <Container>
        <>
          <br />
          <h1 className="text-center">Please verified your email</h1>
          <hr />
          <br />
          <Row>
            <Col className="my-5" md={6}>
              {" "}
              <Form id="loginFrom" noValidate>
                {/* Email */}
                <Form.Group as={Col} md="12" className="mt-3">
                  <Form.Label>Sorry Your Email is not verified yet</Form.Label>
                  <Form.Control
                    required
                    name="email"
                    type="email"
                    value={user?.email}
                    disabled
                  />
                  <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                </Form.Group>
                <br />
                <Button
                  onClick={handleSendverified}
                  variant="success"
                  type="submit"
                >
                  Send Verification
                </Button>
                <br />
                <br />
                <p>
                  Or you can <Link to="/login"> Login</Link>
                </p>
              </Form>
              <br />
            </Col>
            <Col md={6}>
              <img src={forgetPasswordImg} alt="Login Now" />
            </Col>
          </Row>
        </>
      </Container>
    </div>
  );
};

export default EmailVerified;
